








import { Component, Vue, Watch } from 'vue-property-decorator';
import Header from '@/components/global/header/Header.vue';
import Loading from '@/components/Loading.vue';
import { store } from '@/utils/store';
import { exit } from '@/utils/utils';

@Component({
  components: {
    Header,
    Loading,
  },
})
export default class App extends Vue {
  storeData = store;

  get githubId() {
    return store.githubId;
  }

  @Watch('githubId', { immediate: true })
  exit() {
    if (this.githubId === null && this.$route.name !== 'Sign in') exit();
  }
}
